var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"box-div"},[(!_vm.showChildrenSide)?[_c('div',{staticClass:"index-content"},[_c('role-son')],1)]:_vm._e(),(_vm.showChildrenSide)?[_c('div',{staticClass:"index-content-admin"},[_c('master-content')],1)]:_vm._e()],2)}
var staticRenderFns = []

export { render, staticRenderFns }